import { createAction } from '@reduxjs/toolkit';
import { stateName } from './constants';
export const loadRegistrationDefaultValues = createAction("".concat(stateName, "/loadRegistrationDefaultValues"));
export const submitRegistration = createAction("".concat(stateName, "/submitRegistration"), _ref => {
  let {
    registrationFields,
    successCallback
  } = _ref;
  return {
    payload: {
      registrationFields
    },
    meta: {
      successCallback
    }
  };
});
export const updateRegistration = createAction("".concat(stateName, "/updateRegistration"), _ref2 => {
  let {
    registrationFields,
    successCallback,
    validate
  } = _ref2;
  return {
    payload: {
      registrationFields
    },
    meta: {
      successCallback,
      validate
    }
  };
});
export const updateLegalEntity = createAction("".concat(stateName, "/updateLegalEntity"));
export const fetchFormConfigurationRequest = createAction("".concat(stateName, "/fetchFormConfigurationRequest"));
export const fetchFormConfigurationFailure = createAction("".concat(stateName, "/fetchFormConfigurationFailure"));
export const submitKybFormRequest = createAction("".concat(stateName, "/submitKybFormRequest"));